module.exports = __webpack_public_path__ + "media/images/robot_sucesso_mail-1d1a44d12b66c7b78a3547bb7d00cc96.svg";